import changeTheNumber from "./updown";
import saveInputParameters from "./inputBox";
import {
    saveSelectedPlant,
    saveSelectedMachine,
    saveSelectedShift,
    saveSelectedShiftDate,
    saveSelectedMachineType,
    saveSelectedLine,
    timings
} from "./inputbar";

import {
    combineReducers
} from "redux";

const reducers = combineReducers({
    changeTheNumber,
    saveInputParameters,
    saveSelectedPlant,
    saveSelectedMachineType,
    saveSelectedLine,
    saveSelectedMachine,
    saveSelectedShift,
    saveSelectedShiftDate,
    timings
});

export default reducers;